import styled from 'styled-components';
import media from 'styled-media-query';
import { Link } from 'react-router-dom';

import { ColumnContentLarge } from 'styles/ColumnContent';

export const UserTypeWrapper = styled.div`
    background-color: #F2F2F2;
    padding: 1.5rem 0;
    margin-bottom: 4rem;

    ${media.greaterThan('medium')`
        height: 150px;
        margin-bottom: 5rem;
    `}
`;

export const UserTypeText = styled.p`
    font-size: 1.125rem;
    color: #5B5B5B;

    ${media.lessThan('medium')`
        margin-bottom: 0.75rem;
    `}

    ${media.greaterThan('medium')`
        padding: 1.75rem 0;
    `}
`;

export const CustomColumnContentLarge = styled(ColumnContentLarge)`
    ${media.greaterThan('medium')`
        display: grid;
        grid-gap: 1rem;
        grid-template-columns: 1fr 1fr;
    `}
`;

export const UserTypeCardIcon = styled.div`
    background: url(${({ icon }) => icon}) no-repeat center;
    display: none;
    height: 30px;
    margin-bottom: 0.5rem;
    width: 30px;
`;

export const UserTypeCardTitle = styled.p``;

export const UserTypeCardTitleHighlight = styled.p`
    color: var(--main-color);
    font-size: 1.5rem;
    margin-bottom: 1rem;
`;

export const UserTypeCardText = styled.p`
    font-size: 0.875rem;
`;

export const UserTypeCard = styled(Link)`
    background-color: #FFFFFF;
    border-radius: 1rem ;
    box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    display: block;
    padding: 1.5rem;
    position: relative;

    ${media.lessThan('medium')`
        &:not(:last-child) {
            margin-bottom: 0.75rem;
        }
    `}

    ${media.greaterThan('medium')`
        height: 150px;
        &:hover {
            height: auto;
            top: -10px;

            ${UserTypeCardIcon} {
                display: block;
            }
        }

        ${UserTypeCardTitle} {
            color: var(--main-color);
        }

        ${UserTypeCardTitleHighlight} {
            text-decoration: underline;
        }
    `}
`;